"use client"
import { usePathname } from "next/navigation";
import { ReactNode } from "react";

export default function NavbarHomepageBlock({children}: {children: ReactNode}) {
  const pathname = usePathname();

  return pathname == "/" ? children : null;
}